import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

export interface GlobalRadioGroupOptions {
    label: string;
    value: string | number;
}

export interface GlobalRadioGroupProps {
    onChange: (name: string, value: string | number) => void;
    options: GlobalRadioGroupOptions[];
    name: string;
    type: string;
    checkedOptionValue: string | number;
}

const GlobalRadioGroup = (props: GlobalRadioGroupProps) => {
    const { onChange, name, options, type, checkedOptionValue } = props;

    return (
        <RadioGroup
            row
            name={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const { value, name } = e.target;

                switch (type) {
                    case 'number':
                        onChange(name, parseInt(value));
                        break;
                    default:
                        onChange(name, value);
                        break;
                }
            }}
        >
            {options.map((option, index) => (
                <FormControlLabel
                    key={index}
                    checked={checkedOptionValue === option.value}
                    value={option.value}
                    control={<Radio />}
                    label={option.label}
                />
            ))}

        </RadioGroup>
    );
};

export default GlobalRadioGroup;

